export type DndRace = 'any' | 'human' | 'elf' | 'dwarf' | 'orc' | 'halfling' | 'tiefling' | 'dragonborn' | 'gnome' | 'drow';

interface DndNameGeneratorOptions {
    count?: number;
    race?: DndRace;
}

const HUMAN_NAMES = {
    prefixes: ['Al', 'Bar', 'Ced', 'Dav', 'Ed', 'Fal', 'Gar', 'Hal', 'Ian', 'Jar', 'Kal', 'Lam', 'Man', 'Nor', 'Or', 'Pa', 'Qu', 'Ral', 'Sam', 'Tan', 'Val', 'Wil', 'Xan', 'Yar', 'Zan'],
    suffixes: ['ric', 'don', 'win', 'ard', 'mund', 'ton', 'ley', 'son', 'red', 'gar', 'brand', 'bert', 'cus', 'dan', 'eric', 'fred', 'greg', 'hank', 'is', 'jack', 'ken', 'lio', 'mark', 'nick', 'os'],
    surnames: ['Baker', 'Carter', 'Drake', 'Evans', 'Fletcher', 'Green', 'Harris', 'Ives', 'Jones', 'King', 'Lewis', 'Mason', 'Nash', 'O', 'Parker', 'Quinn', 'Reed', 'Smith', 'Taylor', 'Underwood', 'Vance', 'White', 'Young', 'Zane']
};

const ELF_NAMES = {
    prefixes: ['Adrie', 'Birel', 'Cha', 'Dra', 'En', 'Faer', 'Gil', 'Heian', 'Ilan', 'Jen', 'Key', 'Leo', 'Mia', 'Nai', 'Ola', 'Pae', 'Quil', 'Rya', 'Sio', 'Thia', 'Ume', 'Val', 'Wyn', 'Xil', 'Yes', 'Zin'],
    suffixes: ['th', 'l', 'nn', 'las', 'ra', 'drin', 'ion', 'win', 'fiel', 'lis', 'ros', 'na', 'kian', 'tris', 'van', 'phine', 'sys', 'ylla', 'wen', 'vyre', 'zaphir'],
    surnames: ['Amastacia', 'Amakiir', 'Galanodel', 'Holimion', 'Liadon', 'Meliamne', 'Naïlo', 'Siannodel', 'Ilphelkiir', 'Xiloscient']
};

const DWARF_NAMES = {
    prefixes: ['Ad', 'Ba', 'Bro', 'Bru', 'Dai', 'Dar', 'Eb', 'Ein', 'Far', 'Gard', 'Har', 'Kil', 'Mor', 'Or', 'Rag', 'Rang', 'Tak', 'Thor', 'Thra', 'Tor', 'Tra', 'Ul', 'Var', 'Vond', 'Whur'],
    suffixes: ['ber', 'din', 'dis', 'dur', 'gar', 'gin', 'gret', 'hild', 'karl', 'li', 'lin', 'mic', 'mon', 'nal', 'ni', 'nord', 'nus', 'rad', 'rik', 'rim', 'rum', 'stus', 'to', 'um', 'var'],
    surnames: ['Battlehammer', 'Brawnanvil', 'Dankil', 'Fireforge', 'Frostbeard', 'Gorunn', 'Holderhek', 'Ironfist', 'Loderr', 'Lutgehr', 'Rumnaheim', 'Strakeln', 'Torunn', 'Ungart']
};

const ORC_NAMES = {
    prefixes: ['Ar', 'Bar', 'Crum', 'Der', 'Dra', 'Dur', 'Gar', 'Gnar', 'Grum', 'Hro', 'Kar', 'Kro', 'Lok', 'Mar', 'Mur', 'Nar', 'Ogg', 'Rak', 'Rok', 'Thar', 'Thok', 'Urg', 'Var', 'Wurg', 'Zog', 'Zor', 'Gash', 'Kruk', 'Skab', 'Thrak'],
    suffixes: ['bash', 'dash', 'dush', 'gar', 'gash', 'gull', 'htar', 'kash', 'kull', 'lash', 'mush', 'nak', 'rash', 'ruk', 'skab', 'tar', 'thak', 'thrall', 'ur', 'var', 'zog'],
    surnames: [] // Orcs often don't have surnames, or they use clan names similar to first names.
};

const HALFLING_NAMES = {
    prefixes: ['Al', 'An', 'Bel', 'Bo', 'Cad', 'Cor', 'Doc', 'Don', 'El', 'Er', 'Fal', 'Fin', 'Gar', 'Gil', 'Hal', 'Har', 'Id', 'In', 'Jas', 'Jay', 'Kal', 'Ke', 'Lal', 'Le', 'Mer', 'Mil', 'Nor', 'O', 'Per', 'Pip', 'Quin', 'Re', 'Sam', 'San', 'Tan', 'To', 'Ul', 'Ver', 'Wil', 'Xan', 'Yal', 'Zen'],
    suffixes: ['bin', 'bo', 'co', 'da', 'der', 'do', 'don', 'dra', 'dric', 'dry', 'dy', 'fric', 'fry', 'gan', 'go', 'gram', 'grim', 'kan', 'kin', 'lin', 'lo', 'mar', 'min', 'mon', 'nan', 'ni', 'o', 'per', 'pin', 'pip', 'ric', 'rin', 'ro', 'ry', 'ser', 'sin', 'ster', 'ton', 'ty', 'ver', 'vin', 'win', 'wise', 'y'],
    surnames: ['Brushgather', 'Goodbarrel', 'Greenbottle', 'High-hill', 'Hilltopple', 'Leagallow', 'Tealeaf', 'Thorngage', 'Tosscobble', 'Underbough']
};

const TIEFLING_NAMES = {
    prefixes: ['Ak', 'An', 'Bar', 'Bel', 'Cri', 'Dam', 'Ek', 'Iad', 'Kai', 'Leu', 'Me', 'Mor', 'Ni', 'Ori', 'Pai', 'Ri', 'Ska', 'The', 'Tre', 'Val', 'Xar', 'Zai', 'Ze'],
    suffixes: ['ai', 'a', 'bar', 'cis', 'dos', 'emon', 'fi', 'gra', 'ia', 'is', 'ius', 'kas', 'la', 'mea', 'mon', 'na', 'non', 'phis', 'rak', 'ros', 'sis', 'th', 'us', 'via', 'xus'],
    virtueNames: ['Art', 'Carrion', 'Chant', 'Creed', 'Despair', 'Excellence', 'Fear', 'Glory', 'Hope', 'Ideal', 'Music', 'Nowhere', 'Open', 'Poetry', 'Quest', 'Random', 'Reverence', 'Sorrow', 'Temerity', 'Torment', 'Weary']
};

const DRAGONBORN_NAMES = {
    prefixes: ['Ar', 'Bal', 'Bar', 'Cad', 'Dra', 'Dur', 'Gar', 'Ghesh', 'Hes', 'Kriv', 'Med', 'Mehen', 'Nad', 'Nish', 'Pan', 'Pat', 'Qel', 'Rhog', 'Sham', 'Shed', 'Tar', 'Tor', 'Uadj', 'Yull', 'Zor', 'Zra'],
    suffixes: ['ar', 'asar', 'bar', 'bir', 'bor', 'ciar', 'crath', 'darr', 'don', 'dor', 'gar', 'ghall', 'grath', 'hazar', 'jhan', 'kris', 'lan', 'lar', 'mash', 'men', 'mir', 'nall', 'nor', 'par', 'rash', 'rin', 'roth', 'shtal', 'thas', 'urn', 'va', 'var', 'vull', 'wun', 'zan', 'zav'],
    surnames: ['Clethtinthiallor', 'Daardendrian', 'Delmirev', 'Drachedandion', 'Fenkenkabradon', 'Kepeshkmolik', 'Kerrhylon', 'Kimbatuul', 'Linxakasendalor', 'Myastan', 'Nemmonis', 'Norixius', 'Ophinshtalajiir', 'Prexijandilin', 'Shestendeliath', 'Turnuroth', 'Verthisathurgiesh', 'Yarjerit']
};

const GNOME_NAMES = {
    prefixes: ['Al', 'Bi', 'Bod', 'Bro', 'Bum', 'Dim', 'El', 'Er', 'Fim', 'Fon', 'Gim', 'Glim', 'Ig', 'Jeb', 'Kel', 'Nam', 'O', 'Pag', 'Pim', 'Qu', 'Ro', 'Se', 'Sin', 'Tig', 'U', 'Weg', 'Zook'],
    suffixes: ['ble', 'bin', 'bo', 'cob', 'dim', 'don', 'fud', 'gle', 'glim', 'kin', 'lin', 'lo', 'mop', 'ni', 'no', 'pos', 'rug', 'see', 'spin', 'tix', 'to', 'wix', 'y', 'zog', 'zu'],
    surnames: ['Beren', 'Daergel', 'Folkor', 'Garrick', 'Nackle', 'Murnig', 'Ningel', 'Raulnor', 'Scheppen', 'Timbers', 'Turen']
};

const DROW_NAMES = {
    prefixes: ['Ak', 'Aly', 'Bala', 'Bel', 'Char', 'Driz', 'Erel', 'Faer', 'Ghil', 'Hal', 'Il', 'Iln', 'Jar', 'Kal', 'Li', 'Mal', 'May', 'Nal', 'Ned', 'Olor', 'Pellan', 'Pha', 'Phara', 'Qua', 'Quil', 'Rau', 'Sab', 'Shi', 'Sorn', 'Tal', 'Triel', 'Ul', 'Val', 'Vic', 'Xal', 'Xul', 'Yas', 'Zak', 'Zes'],
    suffixes: ['a', 'ace', 'ae', 'afae', 'afay', 'ala', 'anna', 'arra', 'aste', 'avin', 'ayne', 'bryn', 'cice', 'cyne', 'drae', 'drin', 'driz', 'e', 'er', 'ere', 'ess', 'fae', 'fryn', 'i', 'in', 'ice', 'il', 'in', 'intra', 'is', 'ith', 'la', 'leen', 'loop', 'lyn', 'myr', 'na', 'nnee', 'nu', 'nyr', 'ra', 'rae', 'ri', 'rice', 'ryl', 'sha', 'sra', 'ss', 'stra', 'ta', 'tal', 'tana', 'tar', 'th', 'ti', 'trin', 'ue', 'ul', 'wae', 'wi', 'ym', 'yn', 'yr', 'zza'],
    surnames: ['Aleanrahel', 'Aleval', 'Arabani', 'Arkenneld', 'Auvryndar', 'Baenre', 'Barrison', 'Del\'Armgo', 'Despana', 'DeVir', 'Do\'Urden', 'Eilservs', 'Everhue', 'Fey-Branche', 'Filifar', 'Godeep', 'Helviirn', 'Hunzrin', 'Kenafin', 'Kilsek', 'Maethel', 'Melarn', 'Mizzrym', 'Noquar', 'Ousstyl', 'Rilynt\'tar', 'Telenna', 'Tlabbar', 'Tuin\'Tarl', 'Vandree', 'Viirce', 'Xorlarrin', 'Yrryth']
};


const getRandomElement = <T>(array: T[]): T => {
    return array[Math.floor(Math.random() * array.length)];
};

const toTitleCase = (str: string) => {
    return str.replace(/\w\S*/g, (txt) => {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};

const generateName = (dataset: { prefixes: string[], suffixes: string[], surnames?: string[], virtueNames?: string[] }) => {
    // 50% chance to have a surname if available, or force if no firstname parts? 
    // Let's stick to Firstname + Surname if available mostly.

    // For Tieflings, sometimes they use Virtue Names as first name.
    let firstName = "";
    if (dataset.virtueNames && Math.random() > 0.7) {
        firstName = getRandomElement(dataset.virtueNames);
    } else {
        firstName = getRandomElement(dataset.prefixes) + getRandomElement(dataset.suffixes);
    }

    if (dataset.surnames && dataset.surnames.length > 0) {
        const surname = getRandomElement(dataset.surnames);
        return `${toTitleCase(firstName)} ${surname}`;
    }

    return toTitleCase(firstName);
};

export const generateDndNames = ({
    count = 10,
    race = 'any'
}: DndNameGeneratorOptions = {}): string[] => {
    const names: Set<string> = new Set();
    const availableRaces: DndRace[] = ['human', 'elf', 'dwarf', 'orc', 'halfling', 'tiefling', 'dragonborn', 'gnome', 'drow'];

    while (names.size < count) {
        let currentRace = race;
        if (currentRace === 'any') {
            currentRace = getRandomElement(availableRaces);
        }

        let name = '';
        switch (currentRace) {
            case 'human':
                name = generateName(HUMAN_NAMES);
                break;
            case 'elf':
                name = generateName(ELF_NAMES);
                break;
            case 'dwarf':
                name = generateName(DWARF_NAMES);
                break;
            case 'orc':
                name = generateName(ORC_NAMES);
                break;
            case 'halfling':
                name = generateName(HALFLING_NAMES);
                break;
            case 'tiefling':
                name = generateName(TIEFLING_NAMES);
                break;
            case 'dragonborn':
                name = generateName(DRAGONBORN_NAMES);
                break;
            case 'gnome':
                name = generateName(GNOME_NAMES);
                break;
            case 'drow':
                name = generateName(DROW_NAMES);
                break;
        }

        if (name) {
            names.add(name);
        }
    }

    return Array.from(names);
};
